import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef, useState } from 'react';
import Section from '../shared/Section/Section';
import Container from '../shared/Container/Container';
import ProductCard from '../shared/ProductCard/ProductCard';
import NotifyMeModal from '../shared/NotifyMeModal/NotifyMeModal';
import { products } from '../../data/products';
import './Restaurant.css';

const Restaurant = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Section background="light" id="restaurant">
        <Container>
          <div className="restaurant" ref={ref}>
            <div className="restaurant__content">
              <motion.div
                className="restaurant__image"
                initial={{ opacity: 0, x: -50 }}
                animate={isInView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.8 }}
              >
                {/* Image: restaurant_tray_takeout.jpg */}
                {/* Prompt: A takeout tray from a BBQ restaurant with saucy ribs, a disposable rib-shaped sauce cup filled with BBQ sauce, side dishes, napkins, photographed overhead with rustic wood texture. */}
                <img
                  src="/images/restaurant_tray_takeout.jpg"
                  alt="BBQ restaurant takeout tray with Rib-n-Dip wholesale recyclable sauce cups for ribs"
                  className="restaurant__image-main"
                  loading="lazy"
                />
              </motion.div>

              <motion.div
                className="restaurant__text"
                initial={{ opacity: 0, x: 50 }}
                animate={isInView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                <h2 className="restaurant__title">
                  Wholesale BBQ Sauce Cups for Restaurants
                </h2>

                {products.wholesale && (
                  <ProductCard
                    product={products.wholesale}
                    onNotifyClick={() => setIsModalOpen(true)}
                    variant="wholesale"
                    inView={isInView}
                  />
                )}
              </motion.div>
            </div>
          </div>
        </Container>
      </Section>

      {products.wholesale && (
        <NotifyMeModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          productName={products.wholesale.name}
          productId={products.wholesale.id}
        />
      )}
    </>
  );
};

export default Restaurant;
